export const COMPOSER_EMOJI_GROUPS = [
  {
    label: "Faces",
    emojis: [
      "😀", "😃", "😄", "😁", "😆", "😅", "😂", "🤣",
      "😊", "🙂", "🙃", "😉", "😍", "🥰", "😘", "😋",
      "😎", "🤩", "🥳", "🤔", "🫡", "😮", "😢", "😭",
    ],
  },
  {
    label: "Gestures",
    emojis: [
      "👍", "👎", "👏", "🙌", "🙏", "🤝", "👋", "✌️",
      "🤞", "👌", "🤙", "💪", "🫶", "👐", "👀", "💬",
    ],
  },
  {
    label: "Hearts & symbols",
    emojis: [
      "❤️", "🧡", "💛", "💚", "💙", "💜", "🩷", "🤍",
      "💔", "💕", "💖", "💯", "✨", "⭐", "🔥", "🎉",
    ],
  },
  {
    label: "Nature & Aotearoa",
    emojis: [
      "🥝", "🌿", "🌱", "🌳", "🌺", "🌻", "🌈", "☀️",
      "🌙", "⭐", "🌊", "⛰️", "🏕️", "🐦", "🐧", "🇳🇿",
    ],
  },
  {
    label: "Food & activities",
    emojis: [
      "☕", "🍵", "🍕", "🍔", "🍟", "🍜", "🍣", "🍰",
      "🎂", "🎵", "🎧", "🎮", "⚽", "🏉", "🎨", "📚",
    ],
  },
] as const;

export const COMPOSER_EMOJI_COUNT = COMPOSER_EMOJI_GROUPS.reduce(
  (count, group) => count + group.emojis.length,
  0,
);
